
const DEPLOYMENT_ID_COOKIE_NAME = '__vdpl'

const DEPLOYMENT_ID_HEADER_NAME = 'x-deployment-id'

export {
  DEPLOYMENT_ID_COOKIE_NAME,
  DEPLOYMENT_ID_HEADER_NAME,
}